(function ($) {
   var supportsPassive = false;
   try {
      var opts = Object.defineProperty({}, 'passive', {
         get: function () {
            supportsPassive = true;
         }
      });
      window.addEventListener("testPassive", null, opts);
      window.removeEventListener("testPassive", null, opts);
   } catch (e) {
   }

   jQuery.event.special.touchstart = {
      setup: function (_, ns, handle) {
         this.addEventListener("touchstart", handle, supportsPassive ? {passive: !ns.includes("noPreventDefault")} : false);
      }
   };
   jQuery.event.special.touchmove = {
      setup: function (_, ns, handle) {
         this.addEventListener("touchmove", handle, supportsPassive ? {passive: !ns.includes("noPreventDefault")} : false);
      }
   };
   jQuery.event.special.wheel = {
      setup: function (_, ns, handle) {
         this.addEventListener("wheel", handle, supportsPassive ? {passive: true} : false);
      }
   };
   jQuery.event.special.mousewheel = {
      setup: function (_, ns, handle) {
         this.addEventListener("mousewheel", handle, supportsPassive ? {passive: true} : false);
      }
   };

   function isTouchDevice() {
      return /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Windows Phone/i.test(navigator.userAgent) && 'ontouchend' in document;
    }

   // generate rgb color from hex
   function hexToRgb(hex) {
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? {
         r: parseInt(result[1], 16),
         g: parseInt(result[2], 16),
         b: parseInt(result[3], 16)
      } : null;
   }

   function rgb2hex(rgb) {
      rgb = rgb.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
      return (rgb && rgb.length === 4) ? "#" +
         ("0" + parseInt(rgb[1], 10).toString(16)).slice(-2) +
         ("0" + parseInt(rgb[2], 10).toString(16)).slice(-2) +
         ("0" + parseInt(rgb[3], 10).toString(16)).slice(-2) : '';
   }

   // return text color
   function textClr(r, g, b) {
      var cBrightness = ((r * 299) + (g * 587) + (b * 114)) / 1000;
      // console.log(cBrightness);
      if (cBrightness > 115) {
         return true;
      } else {
         return false;
      }
   }

   function luminance(r, g, b) {
      var a = [r, g, b].map(function (v) {
         v /= 255;
         return v <= 0.03928
            ? v / 12.92
            : Math.pow((v + 0.055) / 1.055, 2.4);
      });
      return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
   }

   function getRgb(color) {
      if (color.substring(0) !== "#") {
         color = rgb2hex(color);
         if (color === "#000000") {
            color = "#ffffff";
         }
         return hexToRgb(color);
      }
   }

   function colorTester(el) {
      var bgcolRGB = getRgb(el.parent().css("background-color"));
      var colorRGB = getRgb(el.css("color"));

      if (bgcolRGB && colorRGB) {
         var lumBG = luminance(bgcolRGB.r, bgcolRGB.g, bgcolRGB.b);
         var lumCLR = luminance(colorRGB.r, colorRGB.g, colorRGB.b);

         var ratio = lumBG > lumCLR
            ? ((lumCLR + 0.05) / (lumBG + 0.05))
            : ((lumBG + 0.05) / (lumCLR + 0.05));

         if (ratio < 1 / 7) {
            // console.log("PASS");
         } else {
            if (textClr(bgcolRGB.r, bgcolRGB.g, bgcolRGB.b)) {
               el.addClass("contrast-black");
               if (el.parent().hasClass("teaser--4__title")) {
                  el.parent().addClass("contrast-bg");
               }
               if (el.parents(".page-title-line").length > 0) {
                  el.parents(".page-title-line").addClass("contrast-bg");
               }
            } else {
               el.addClass("contrast-white");
            }
         }
      } else {
         el.addClass("contrast-black");
      }
   }

   /* iOS Hover Fix*/
   function iOSHover() {
      $('.main-nav > ul > .has-sub > a').on('touchstart', function (e) {
         $(this).parents('li').trigger('hover');
      }).on('touchend', function (e) {
         if ($(this).hasClass('touched')) {
            $('.main-nav .has-sub > a').removeClass('touched');
            $(this).trigger('click');
         } else {
            e.preventDefault();
            $('.main-nav .has-sub > a').removeClass('touched');
            $(this).parents('li').trigger('hover');
            $(this).addClass('touched');
         }
      });
   }

   function removeMenuTabindex() {
      $('.header__main-nav > li > div a').attr('tabindex', '-1');
      $('.header__main-nav > li > ul a').attr('tabindex', '-1');
      // $('.header__main-nav .collapse.show').removeClass("show");
   }

   function selectMenuItem(e, mainNav) {
      if ($(e.target).parent().hasClass("selected") === false && $('.burger-btn.open').length < 1) {
         e.preventDefault();
         if ($(e.target).parent().find('.close-btn').length < 1) {
            $(e.target).parent().find('ul').prepend('<a type="button" class="close-btn" title="schließen"></a>');
            $(e.target).parent().find('.special-flyout').prepend('<a type="button" class="close-btn" title="schließen"></a>');
            mainNav.find('.close-btn').off('click').on('click', function (e) {
               mainNav.children('.selected').removeClass("selected");
               removeMenuTabindex();
            })
         }

         mainNav.children('.selected').removeClass("selected");

         var activeElem = $(e.target).parent();
         var closeBtn = activeElem.find('.close-btn');
         var btnShift = closeBtn.width() / 2;
         var touchDevice = isTouchDevice();

         if (closeBtn.parent().hasClass('special-flyout')) {
            var headerPanel = mainNav.closest('.header__main-nav-panel');
            closeBtn.css({
               'visibility': 'visible',
               'top': -(headerPanel.height() + btnShift) + 'px',
               'left': (window.innerWidth - headerPanel.children().eq(0).width()) / 2 + activeElem.outerWidth() - (touchDevice ? btnShift + 14 : btnShift + 22) + 'px'
            });
         } else {
            closeBtn.css({
               'visibility': 'visible',
               'left': activeElem.outerWidth() - btnShift + 'px'
            });
         }

         activeElem.addClass("selected");

         removeMenuTabindex();
         $('.header__main-nav > li.selected > div a').removeAttr('tabindex');
         $('.header__main-nav > li.selected > ul a').removeAttr('tabindex');
      }
   }

   $(function () {

      // Add title for links with target="_blank" (BITV)
      $("a[target='_blank']").attr('title', 'Öffnet Link in neuem Fenster');

      var mainNav = $('.header__main-nav');

      $(window).resize(function(e) {
         if (!e.isTrigger) {
            clearTimeout(this._timer);

            this._timer = setTimeout(function () {
               if (window.outerWidth < 992) {
                  setTimeout(function () {
                     mainNav.find('a').attr('tabindex', '-1');
                  }, 500);
               } else {
                  setTimeout(function () {
                     mainNav.find('a').attr('tabindex', null);
                  }, 500);

                  var activeMenu = mainNav.find('.selected');

                  if (activeMenu.length) {
                     activeMenu.parent().find('.close-btn').css('visibility', 'hidden');
                  }
               }
            });
         }
      });

      $(document).ready(function () {
         iOSHover();

         // $('.search-btn-mobile.collapsed').on('click', function (e) {
         //    e.preventDefault();
         //    setTimeout(function () {
         //       $('#mobilesearch').get(0).focus();
         //    }, 300);
         // });

         var mainNavLinks = $('.header__main-nav > li > a');

         mainNavLinks.mouseenter(function(e) {
            $(this).animate({'visibility':'visible'}, 350, 'swing', function() {
               selectMenuItem(e, mainNav);
            })
         });

         mainNavLinks.mouseleave(function() {
            $(this).removeClass('hoverIntent').stop().clearQueue();
         });

         mainNavLinks.on('click', function (e) {
            selectMenuItem(e, mainNav);
         })


         // ====================================================================================
         // on focus event listener
         // ------------------------------------------------------------------------------------
         $('a, input').on('focus', function (e) {
            if ($(e.target).parents('.header__main-nav').length < 1) {
               mainNav.children('.selected').removeClass("selected");
               mainNav.children('.focused').removeClass("focused");
               removeMenuTabindex();
            }
            // $('.widget-submit-search-field').parent().removeClass('inFocus');
         });

         mainNavLinks.on('focus', function (e) {
            mainNav.children('.focused').removeClass("focused");
            $(e.target).parent().addClass("focused");
         });

         $('.accordion .b-panel .b-panel__title').on('focus', function (e) {
            if ($(this).parents('.b-panel').find('.b-panel__title').hasClass("clicked")) {
               $(this).parents('.b-panel').find('.b-panel__content a').attr('tabindex', '0');
            } else {
               $(this).parents('.b-panel').find('.b-panel__content a').attr('tabindex', '-1');
            }
         });

         $('.more-content-panel .btn.btn_toggle-content').on('click', function (e) {
            if ($(this).hasClass("clicked")) {
               $(this).parents(".more-content-panel").find(".focus-handle").attr('tabindex', '0').focus();
               setTimeout(function () {
                  $(this).parents(".more-content-panel").find(".focus-handle").focus();
               }, 500);
            } else {
               $(this).parents(".more-content-panel").find(".focus-handle").attr('tabindex', '-1');
            }
         });

         $('.widget-submit-search-field').on('focus', function (e) {
            $(this).parent().addClass('inFocus');
         });
         // ====================================================================================

         // This code would be placed in the method that opens the modal/menu:
         $(document).keyup(function (event) {
            if (event.keyCode === 27) {
               if ($(event.currentTarget.activeElement).parents('li.selected').length > 0) {
                  $('.header__main-nav > li.selected > a').focus();
                  removeMenuTabindex();
                  mainNav.children('.selected').removeClass("selected");
               }
               if ($('.btn_burger.clicked').length > 0) {
                  collapsedElem = mainNav.find('.collapse.show');

                  if (collapsedElem.length > 0) {
                     collapsedElem.removeClass('show');
                  } else {
                     $('.btn_burger.clicked').trigger('click');
                     collapsedElem.removeClass("show");
                     $(document).scrollTop(0);
                     $('.btn_burger').focus();
                  }
               }
               if ($(event.currentTarget.activeElement).parents('.accordion').length > 0) {
                  $(event.currentTarget.activeElement).parents('.b-panel').find('b-panel__title').trigger('click').focus();
               }
            }

            if (event.keyCode === 13) {
               // if ($(event.currentTarget.activeElement).attr('data-parent') && $(event.currentTarget.activeElement).hasClass('#accordion')) {
               //    $(event.currentTarget.activeElement).parents('.panel').find('.panel-body a').attr('tabindex', '0');
               // }
               // if ($(event.currentTarget.activeElement).attr('class') && $(event.currentTarget.activeElement).hasClass('search-btn-mobile')) {
               //    $($(event.currentTarget.activeElement).attr('href')).find('input[type="text"]').focus();
               // }
               if ($(event.currentTarget.activeElement).attr('class') && $(event.currentTarget.activeElement).hasClass('cc-dismiss')) {
                  $(event.currentTarget.activeElement).trigger('click');
               }
               if ($(event.currentTarget.activeElement).attr('class') && $(event.currentTarget.activeElement).hasClass('btn_up')) {
                  $('.header .logo').focus();
               }
               if ($(event.currentTarget.activeElement).parents('.accordion').length > 0) {
                  $(event.currentTarget.activeElement).trigger('click').focus();
               }
               if ($(event.currentTarget.activeElement).parent().parent().hasClass('header__main-nav') && $(event.currentTarget.activeElement).parent().hasClass('focused')) {
                  // console.log($(event.currentTarget.activeElement).parent().find('ul').length > 0);
                  if ($(event.currentTarget.activeElement).parent().find('ul').length > 0) {
                     var href = $(event.currentTarget.activeElement).attr('href');
                     var char = '#';
                     if (href.substring(0, 1) === char) event.preventDefault();
                     selectMenuItem(event, mainNav);
                  }
               }
            }
         });

         $(document).on('click', function (e) {
            var obj = $('#searchField, #searchFieldMobile');
            var target = $(e.target);
            if (target.attr('type') !== 'text') {
               if (obj.hasClass('in')) {
                  obj.removeClass('in');
               }
            }
         });

         var colorElements = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'a', 'p', 'b', '.c-parent', '.nice-select', '.specialists-list button', 'span', 'h2', 'strong', 'li', 'button', 'time', 'small', 'font', '.sr-only', '.date', '.btn'];
         if (sessionStorage.getItem('contrastMode') && sessionStorage.getItem('contrastMode') === 'on') {
            $("#contrast-toggle").addClass("on");
            for (var i = 0; i < colorElements.length; i++) {
               if ($(colorElements[i]) && $(colorElements[i]).length > 0) {
                  $(colorElements[i]).each(function () {
                     colorTester($(this));
                  });
               }
            }
         }

         $("#contrast-toggle").on("click", function (e) {
            var $this = $(this);
            if ($this.hasClass("on")) {
               $this.removeClass("on");
               $('.contrast-black').removeClass('contrast-black');
               $('.contrast-white').removeClass('contrast-white');
               $('.contrast-bg').removeClass('contrast-bg');
               $("#contrast-toggle").attr('title', 'Hoher Kontrast anschalten');
               sessionStorage.setItem('contrastMode', 'off');
            } else {
               $this.addClass("on");
               $("#contrast-toggle").attr('title', 'Hoher Kontrast ausschalten');
               for (var i = 0; i < colorElements.length; i++) {
                  if ($(colorElements[i]) && $(colorElements[i]).length > 0) {
                     $(colorElements[i]).each(function () {
                        colorTester($(this));
                     });
                  }
               }
               sessionStorage.setItem('contrastMode', 'on');
            }
         });
      });
   });

})(jQuery);
